var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useTWMergeContext } from '@marketing/TWMergeContext';
import { clsx } from 'clsx';
function FlexSection(_a) {
    var children = _a.children, gapStyle = _a.gapStyle, backgroundColorStyle = _a.backgroundColorStyle, paddingStyle = _a.paddingStyle, _b = _a.useMaxWidth, useMaxWidth = _b === void 0 ? true : _b, className = _a.className, flexStyle = _a.flexStyle, id = _a.id;
    var defaultFlexStyle = 'flex flex-col md:flex-row justify-start md:justify-between md:items-center w-full overflow-hidden';
    var twMerge = useTWMergeContext().twMerge;
    return (_jsx("section", __assign({ id: id, className: clsx('w-full overflow-hidden', backgroundColorStyle) }, { children: _jsx("div", __assign({ className: clsx(twMerge(defaultFlexStyle, flexStyle), backgroundColorStyle, useMaxWidth && 'md:max-w-2xl md:mx-auto', gapStyle, paddingStyle, className) }, { children: children })) })));
}
export default FlexSection;
